import React from 'react';
import { cn } from 'src/tef/components/utils/cn';
import { forwardProps } from 'src/tef/components/utils/forwardProps';
import type { ForwardedHTMLProps } from 'src/tef/components/utils/types';

interface ContentSectionProps extends ForwardedHTMLProps {
  children: React.ReactNode;
  padding?: 'none' | 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
  id?: string;
}

const paddingClasses = {
  none: '',
  sm: 'py-4',
  md: 'py-8',
  lg: 'py-12',
  xl: 'py-16',
};

export const ContentSection = React.forwardRef<HTMLElement, ContentSectionProps>(
  ({ children, padding = 'md', className, id, ...props }, ref) => {
    const forwardedProps = forwardProps(props);

    return (
      <section ref={ref} id={id} className={cn(paddingClasses[padding], className)} {...forwardedProps} {...props}>
        {children}
      </section>
    );
  }
);

ContentSection.displayName = 'ContentSection';
